<template>
<div class="mlist__item van-hairline--bottom">
  <div class="info" :class="{'hasimg':detail.img_path!=0 && listType!='asklist'}">
    <div class="title" :class="{'ask__title':listType=='asklist'}">
      <span class="title__span van-multi-ellipsis--l2">{{detail.title}}</span>
      <div class="tag" v-if="listType=='asklist'">
        <van-tag type="success" v-if="listType=='asklist' && detail.status==1">已解答</van-tag>
        <van-tag v-if="listType=='asklist' && detail.status==0">未解答</van-tag>
      </div>
    </div>
    <div class="time">
      <span>{{detail.add_time}}</span>
    </div>
  </div>
  <div class="other" v-if="detail.img_path!=0 && detail.img_path!=null">
    <div class="img" :style="{backgroundImage:'url('+detail.img_path+')'}"></div>
  </div>
</div>
</template>
<script>
export default {
  data() {
    return {
      detail: {},
      listType:null
    }
  },
  props: ['item','type'],
  components: {},
  computed: {
    host() {
      return window.g.host
    }
  },
  watch: {},
  created() {
    this.detail = this.item
    let {
      type
    }=this
    if(typeof type =='undefined'){
      this.listType=null
    }else{
      this.listType=type
    }
  },
  mounted() {},
  onShow() {},
  methods: {}
}
</script>
<style lang="less" scoped>
.mlist__item {
    padding: 15px 20px;
    box-sizing: border-box;
    background: #fff;
    display: flex;
    .info {
        flex: 1;
        &.hasimg {
            flex: 0 0 70%;
        }
        .title {
            font-size: 16px;
            max-height: 45px;
            line-height: 22px;
            font-weight: bold;
            &.ask__title{
              display: flex;
              .title__span{
                display: block;
                flex: 1;
              }
              .tag{
                flex:0 0 50px;
                text-align: right;
              }
            }
        }
        .time {
            font-size: 12px;
            color: @sub_gray;
            margin-top: 10px;
        }
    }
    .other {
        flex: 1;
        margin-left: 10px;
        .img {
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            width: 100%;
            height: 50px;
            border-radius: 5px;
            overflow: hidden;
        }
    }
}
</style>
